<template>
  <div>
    <template v-if="$store.getters.currentRoomType">
      <template v-if="$store.getters.currentRoomType.DISPLAY?.ROOM_ADA">
        <a v-if="false !== isRoomTypeVariantExists('ROOM_ADA', true, $store.state.currentPrtId)"
           title="Click to Change" href="#"
           @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])">
          {{ $store.getters.currentRoomType.DISPLAY.ROOM_ADA_VARIANT }}
        </a>
        <template v-else>
          {{ $store.getters.currentRoomType.DISPLAY.ROOM_ADA_VARIANT }}
        </template>
      </template>
      <template v-else>
        <a v-if="false !== isRoomTypeVariantExists('ROOM_ADA', true, $store.state.currentPrtId)"
           title="Click to See Accessible Room Options" href="#"
           @click.prevent="$store.commit('updateState', ['isVariantDialogVisible', true])">Available</a>
      </template>
      <template v-else>
        No
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "quick-details-ada",
  methods: {
    isRoomTypeVariantExists(dataKey: string, dataValue: boolean, omitPrtId = 0, valueModifierFunction = (val: string) => val) {
      for (let i = 0, l = this.$store.state.roomData.length; i < l; i++) {
        if (this.$store.state.roomData[i].PRT_ID !== omitPrtId && this.$store.state.roomData[i].DISPLAY && dataKey in this.$store.state.roomData[i].DISPLAY && dataValue === valueModifierFunction(this.$store.state.roomData[i].DISPLAY[dataKey])) {
          return parseInt(this.$store.state.roomData[i].PRT_ID, 10);
        }
      }
      return false;
    }
  }
})
</script>

<style scoped>

</style>